module.exports = __webpack_public_path__ + "static/valkur-symbol-DND3_FnP-0992764e99215796ecd019b357578923.webp";